import styled from "styled-components"

import {Row} from "react-bootstrap"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {H2, H4, Body} from "@irati/ui/src/Typography"
import Link from "@irati/ui/src/Link"
import Banner from "@irati/ui/src/Banner"
import padding from "@irati/ui/src/global/padding"

import banner from "../../images/banner.jpg"

export const InformationText = styled.div`
  min-height: auto;
  padding-bottom: ${padding.small};
  ${minWidthMedia.desktop`
    min-height: 190px;
    padding-bottom: ${padding.base};
  `}
`

export const WhiteH2 = styled(H2)`
  color: ${({theme}) => theme.colors.greys.white};
  max-width: 250px;
  ${minWidthMedia.tablet`
    max-width: 100%;
  `}
`

export const WhiteH4 = styled(H4)`
  color: ${({theme}) => theme.colors.greys.white};
`

export const Flex = styled.div`
  display: flex;
`

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Small = styled(Body)`
  color: #bbb;
`

export const StyledLink = styled(Link)`
  color: #bbb;
`

export const BannerHeadings = styled.div`
  max-width: 400px;
  margin-right: ${padding.small};
  ${minWidthMedia.desktop`
    max-width: 500px;
  `}
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StyledRow = styled(Row)`
  margin-bottom: ${padding.large};
`

export const MobileBanner = styled(Banner)`
  display: flex;
  align-items: center;
  background: linear-gradient(rgba(20, 20, 20, 0.3), rgba(20, 20, 20, 0.3)), url(${banner});
  background-position: top center;
  background-size: cover;
`

export const StyledBanner = styled(Banner)`
  background: linear-gradient(rgba(20, 20, 20, 0.3), rgba(20, 20, 20, 0.3)), url(${banner});
  background-position: 0 34%;
  background-size: cover;
`
